<template>
    <div class="parent">
        <div class="dualside-container">
          <div class="left-parent">
          <confirmation-options
            :email="email"
            :hasDownPaymentBillet="hasDownPaymentBillet"
            :downPayment="downPayment"
            @detailsClick="toggleDrawerProposalDetails"
          />
          </div>
          <div class="details-parent">
            <div class="details-side" id="right">
              <proposal-info
                v-if="source === 'imobiliaria'"
                :proposalId="proposalId"
              />
              <checkout-info
              v-else
              style="margin: 0;"
              :order="order"
              :products="products" :user="user" />
            </div>
          </div>
        </div>

        <template v-if="isSmall && source !== 'imobiliaria' && !showResendOptions">
          <div
            v-if="step === 'COMPLETE' && !paidWithCredit"
            class="more-details primary"
            @click="() => $router.push('/portal')"
          >
            <p>
              Acessar o Parcelex
            </p>
          </div>

          <div
            v-else
            class="more-details"
            @click="toggleDrawerOrderDetails"
          >
            <p>
              Detalhes do pedido
            </p>
          </div>

        </template>
      <drawer-right
        :visible="drawerEntrance || drawerDocument || drawerOrderDetails || drawerProposalDetails"
        :close="closeDrawer"
        :size="rightSize"
      >
        <div class="drawer" v-if="drawerEntrance" slot="drawer-content">
          <div
            v-if="!isOnlyCredit"
            class="close-button"
            :style="{display: drawerEntrance ? 'block' : 'none'}"
            @click="() => closeDrawer()"
          >
            <asset-v3 v-if="isSmall" dir="icons" name="arrow-left.svg"/>
            <asset-v3 v-else dir="icons" name="close.svg"/>
          </div>
          <entrance-payment-drawer :downPayment="downPaymentInfo" />
        </div>
        <div class="drawer" v-else-if="drawerDocument" slot="drawer-content">
          <div
            class="close-button"
            :style="{display: drawerDocument ? 'block' : 'none'}"
            @click="() => closeDrawer()"
          >
            <asset-v3 v-if="isSmall" dir="icons" name="arrow-left.svg"/>
            <asset-v3 v-else dir="icons" name="close.svg"/>
          </div>
          <send-documents-drawer
            :phone="phone"
            :onboardingToken="onboardingToken"
            :transactionId="transactionId"
            :bypassDocuments="bypassDocuments"
          />
        </div>
        <div class="drawer" v-else-if="drawerOrderDetails" slot="drawer-content">
          <div
            class="close-button"
            :style="{display: drawerOrderDetails ? 'block' : 'none'}"
            @click="() => closeDrawer()"
          >
            <asset-v3 v-if="isSmall" dir="icons" name="arrow-left.svg"/>
            <asset-v3 v-else dir="icons" name="close.svg"/>
          </div>
          <order-details-drawer :order="order" :products="products" :user="user"/>
        </div>
        <div
          class="proposal-info"
          v-else-if="drawerProposalDetails"
          slot="drawer-content"
        >
          <proposal-info
            :proposalId="proposalId"
          />
        </div>
      </drawer-right>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import UtilMixing from '@/mixins/util';
import StringMixing from '@/mixins/string';

import AssetV3 from '@/components/common/AssetV3.vue';
import CheckoutInfo from './CheckoutInfo.vue';
import ProposalInfo from '../../tenant/components/ProposalInfo.vue';
import ConfirmationOptions from './ConfirmationOptions.vue';
import DrawerRight from './DrawerRight.vue';
import EntrancePaymentDrawer from './EntrancePaymentDrawer.vue';
import SendDocumentsDrawer from './SendDocumentsDrawer.vue';
import OrderDetailsDrawer from './OrderDetailsDrawer.vue';

export default {
  name: 'next-steps-v2',
  mixins: [UtilMixing, StringMixing],
  components: {
    DrawerRight,
    CheckoutInfo,
    ProposalInfo,
    ConfirmationOptions,
    EntrancePaymentDrawer,
    SendDocumentsDrawer,
    OrderDetailsDrawer,
    AssetV3,
  },
  data: () => ({
    status: [],
    proposalId: null,
    totalRightSize: 0,
  }),
  computed: {
    ...mapState('onboarding', [
      'name',
      'phone',
      'email',
      'zipCode',
      'city',
      'state',
      'address',
      'orderId',
      'createdAt',
      'products',
      'downPayment',
      'totalValue',
      'downPaymentValue',
      'downPaymentPercentage',
      'totalAmount',
      'numberOfInstallments',
      'paymentInstallments',
      'interest',
      'drawerEntrance',
      'drawerDocument',
      'drawerOrderDetails',
      'drawerProposalDetails',
      'barCodeNumber',
      'payNumber',
      'downPaymentLink',
      'downPaymentPixAvailable',
      'downPaymentPixCode',
      'downPaymentDueDate',
      'isCreditCardAvailable',
      'onboardingToken',
      'transactionId',
      'transaction',
      'source',
      'step',
      'bypassDocuments',
      'showResendOptions',
    ]),
    ...mapState('theme', ['theme']),
    user() {
      return {
        name: this.name,
        address: this.address,
        city: this.city,
        state: this.state,
        zipCode: this.zipCode,
        phone: this.phone,
      };
    },
    isOnlyCredit() {
      return this.$route.query?.payWithCredit;
    },
    paidWithCredit() {
      return this.$route.query?.payWithCreditPaid;
    },
    order() {
      return {
        orderId: this.orderId,
        downPaymentPercentage: this.downPaymentPercentage,
        downPaymentValue: this.downPaymentValue,
        numberOfInstallments: this.numberOfInstallments,
        paymentInstallments: this.paymentInstallments,
        interest: this.interest,
        totalAmount: this.totalAmount,
        createdAt: this.createdAt,
      };
    },
    downPaymentInfo() {
      return {
        downPaymentValue: this.downPaymentValue,
        downPaymentDueDate: 1,
        downPaymentPixCode: this.downPaymentPixCode,
        downPaymentPixAvailable: this.downPaymentPixAvailable,
        isCreditCardAvailable: this.isCreditCardAvailable,
        downPaymentLink: this.downPaymentLink,
        barCodeNumber: this.barCodeNumber,
        payNumber: this.payNumber,
        retailerName: this.transaction.retailerName,
      };
    },
    isSmall() {
      return this.isMobile();
    },
    hasDownPaymentBillet() {
      if (this.transaction && this.transaction.downPaymentBillet) {
        return this.transaction.downPaymentBillet;
      }
      return false;
    },
    rightSize() {
      return this.totalRightSize / 2;
    },
  },
  mounted() {
    document.documentElement.setAttribute('theme', this.theme);
    this.proposalId = this.$route.query.proposalId;

    if (this.$route.query.payWithCredit) {
      this.setDrawerEntrance(true);
    } else {
      this.setDrawerEntrance(false);
    }

    this.totalRightSize = this.rightElementSizeHandler();

    window.addEventListener('resize', () => {
      this.totalRightSize = this.rightElementSizeHandler();
    });
    document.body.setAttribute('style', 'overflow: visible;overflow-x: hidden;');
  },
  methods: {
    ...mapMutations('onboarding', [
      'setDrawerEntrance',
      'setDrawerDocument',
      'setDrawerOrderDetails',
      'setDrawerProposalDetails',
      'updateStep',
    ]),
    rightElementSizeHandler() {
      const totalWidthSize = document.body.clientWidth;

      return totalWidthSize;
    },
    closeDrawer() {
      this.setDrawerEntrance(false);
      this.setDrawerDocument(false);
      this.setDrawerOrderDetails(false);
      this.setDrawerProposalDetails(false);
    },
    toggleDrawerOrderDetails() {
      this.setDrawerOrderDetails(true);
    },
    toggleDrawerProposalDetails() {
      this.setDrawerProposalDetails(true);
    },
  },
};
</script>

<style lang="scss" scoped>

.parent {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;

  @media (min-width: $md) {
    overflow: hidden;
  }
}

.dualside-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 40px);
  max-width: 1000px;

  @media (min-width: 1024px) {
    margin-left: auto;
    margin-right: auto;
    flex-direction: row;
    justify-content: center;
  }

  .left-parent {
    display: flex;
    position: relative;
    // padding: 24px;
    flex-direction: column;
    min-height: 100%;

    @media (min-width: 1024px) {
      position: sticky;
      padding: 24px 36px;
      flex-direction: row;
      width: 100%;
      max-width: 558px;
    }

    .left-side {
      display: flex;
      position: relative;
      flex-direction: column;
      gap: 24px;
      height: 100%;
      color: #0f172a;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }
  }

  .details-parent {
    display: none;

    @media (min-width: 1024px) {
      display: flex;
      flex-grow: 1;
      width: 100%;
      min-height: 100%;
    }

    .details-side {
      display: flex;
      position: relative;
      padding: 24px 36px;
      flex-direction: column;
      gap: 24px;
      max-width: 370px;
      width: 100%;
      min-height: 100%;
      background-color: #f3f4f6;

      &:after {
        content: "";
        display: none;

        @media (min-width: 1024px) {
          display: block;
          position: absolute;
          background: #f3f4f6;
          top: 0;
          left: 100%;
          width: 100vw;
          height: 100%;
        }
      }
    }

    @media (min-width: 1024px) {
      display: block;
    }
  }
}
  // .onboarding-next-steps-wrapper {
  //   width: 100%;
  //   display: flex;
  //   justify-content: center;
  //   max-width: 964px !important;
  //   margin: auto;
  //   min-height: 100vh;
  //   box-sizing: border-box;

  //   @media (max-width: $sm) {
  //     background-color: var(--white);
  //     flex-direction: column;
  //     align-items: center;
  //     padding-top: 0;
  //   }
  // }

  .bg-gray {
    background-color: var(--gray-100);
    position: fixed;
    top: 0;
    left: 50%;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
  .left {
    max-width: 486px;
    background: #FFFFFF;
  }
  .right {
    max-width: 442px;
    background-color: var(--gray-100);
  }
  .more-details {
    width: calc(100% - 48px);
    height: 48px;
    bottom: 40px;
    position: absolute;
    display: flex;
    z-index: 100;
    align-self: center;
    font-size: 16px;
    // margin:auto 0;
    left:0;
    right:0;
    margin-left: auto;
    margin-right: auto;
    line-height: 24px;
    color: var(--gray-900);

    border: 1px solid #CBD5E1;
    border-radius: 6px;

    p {
      width: 100%;
      display: flex;
      justify-content: center;
      align-self: center;
    }

    &.primary {
      color: var(--white);
      font-weight: 600;

      background-color: var(--blue-400);

      border: 0;
    }
  }
  @media (max-width: $sm) {
    .left {
      width: 100%;
      background: #FFFFFF;
      height: 100vh;
    padding-left: unset;
    }
    .right {
      display: none;
    }
    .bg-gray {
      display: none;
    }
  }
</style>
<style lang="scss">
.drawer-right-wrapper .drawer {
  padding-top: 32px;
  position: absolute;
  padding-right: 24px;
  padding-left: 24px;
  z-index: 999;
  max-width: 600px;
  left: unset !important;
}
@media (max-width: $sm) {
  .drawer-right-wrapper .drawer {
    padding-top: 32px;
    position: absolute;
    padding-right: 24px;
    padding-left: 24px;
    width: auto;
    left: unset !important;
  }
}
.drawer-right-wrapper .proposal-info {
  padding: 24px;
}
</style>
